const info = 
{
    title: "Ambition",
    type: "Short Film"
};

export default info;